import './assets/App.css';
import React from "react";
import { gsap } from "gsap";

// import PortfolioContainer from "./Components/PortfolioContainer";

import Header from './Components/Pages/Header';
// const App = () => <PortfolioContainer />;
const App = () => <Header />;

export default App;
